import { Routes, Route } from "react-router-dom";
import AdminLayout from "../components/Admin/AdminLayout";
import AdminLoginPage from "../pages/Auth/AdminLoginPage";
import AdminProtectedRoute from "./AdminProtectedRoute";
import HomePageAdmin from "../pages/Admin/Dashboard";
import AdvisorListPage from "../pages/Admin/DanismanListPage";
import CompanyListPage from "../pages/Admin/CompanyListPage";
import AdminSettingsPage from "../pages/Admin/AdminSettingsPage";
import SiteSettingsPage from "../pages/Admin/SiteSettingsPage";
import AdminLogoutPage from "../pages/Admin/LogoutPage";

import AdminManagementPage from "../pages/Admin/UserManagement/AdminsListPage"; // YENİ IMPORT
import OgrenciListPage from "../pages/Admin/StudentManagement/AllStudentsPage";
import LessonGroupManagementPage from "../pages/Admin/DersGrubu";
import TeacherListPage from "../pages/Admin/TeacherManagement/TeacherListPage";
import PastLessonsPage from "../pages/Admin/TeacherManagement/PastLessonsPage";
import KursSatisListPage from "../pages/Admin/TeacherManagement/KursSatisPage";
import TodoListPage from "../pages/Admin/TodoListPage";
import AvansPage from '../pages/Admin/AccountingManagement/Avans';
import TeacherReportPage from '../pages/Admin/AccountingManagement/ReportManagement/TeacherReportPage';
import GelenOdemeler from '../pages/Admin/AccountingManagement/GelenOdemeler';
import DanismanlarReportPage from '../pages/Admin/AccountingManagement/ReportManagement/DanismanlarReportPage';
import CompaniesReportPage from '../pages/Admin/AccountingManagement/ReportManagement/CompaniesReportPage';
import MailSmsManagementPage from '../pages/Admin/MailSmsManagement/MailSmsManagementPage';
import DatabaseManagement from '../pages/Admin/DatabaseManagement';
import NotificationsPage from '../pages/Admin/NotificationsPage';
import LocationManagementPage from '../pages/Admin/LocationManagement/LocationManagementPage';
import BankManagement from '../pages/Admin/BankManagement';




const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<AdminLoginPage />} />
      <Route path="/" element={
        <AdminProtectedRoute>
          <AdminLayout />
        </AdminProtectedRoute>
      }>
        <Route index element={<HomePageAdmin />} />
        <Route path="advisors" element={<AdvisorListPage />} />
        <Route path="companies" element={<CompanyListPage />} />
        <Route path="settings" element={<AdminSettingsPage />} />
        <Route path="site-settings" element={<SiteSettingsPage />} />
        <Route path="logout" element={<AdminLogoutPage />} />

        <Route path="management" element={<AdminManagementPage />} /> {/* YENİ ROUTE */}
        <Route path="student-management/all" element={<OgrenciListPage />} />
        <Route path="lesson-groups" element={<LessonGroupManagementPage />} />
        <Route path="teacher-management/all" element={<TeacherListPage />} />
        <Route path="teacher-management/past-lessons" element={<PastLessonsPage />} />
        <Route path="teacher-management/kurs-satis" element={<KursSatisListPage />} />
        <Route path="todo" element={<TodoListPage />} />
        <Route path="accounting/avans" element={<AvansPage />} />
        <Route path="accounting/reports/teacher" element={<TeacherReportPage />} />
        <Route path="accounting/gelen-odemeler" element={<GelenOdemeler />} />
        <Route path="accounting/reports/danismanlar" element={<DanismanlarReportPage />} />
        <Route path="accounting/reports/companies" element={<CompaniesReportPage />} />
        <Route path="mail-sms-management" element={<MailSmsManagementPage />} />
        <Route path="database" element={<DatabaseManagement />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="location-management" element={<LocationManagementPage />} />
        <Route path="bank-management" element={<BankManagement />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;